<template>
  <div
    class="bg-primary-pure/5 text-neutral-100 py-2 px-12 rounded-xl !font-medium text-headline-4 inline-flex"
  >
    {{ text }}
  </div>
</template>

<script setup>
const props = defineProps({
  text: String,
})
</script>

<style lang="sass" scoped></style>
